module.exports = __webpack_public_path__ + "img/bg-proyectos-4.e300d6c4.png";